import { useQuery } from '@tanstack/react-query';
import { TaskItem } from '@demind-inc/core';

import { tasksApi } from '../api';

interface UseSearchTasksParams {
  query: string;
  limit?: number;
  enabled?: boolean;
}

interface UseSearchTasksQueryKey {
  queryKey: ['lifestack.tasks.search', string, number];
}

export const useSearchTasks = ({ query, limit = 10, enabled = true }: UseSearchTasksParams) => {
  const trimmedQuery = query.trim();
  const searchTasksQuery = useQuery({
    queryKey: ['lifestack.tasks.search', trimmedQuery, limit],
    queryFn: ({ queryKey }: UseSearchTasksQueryKey) => {
      const [, searchQuery, maxResults] = queryKey;
      return tasksApi.searchTasks(searchQuery, maxResults).then(({ data }) => data as TaskItem[]);
    },
    enabled: enabled && !!trimmedQuery,
    staleTime: 30_000,
  });

  return {
    tasks: searchTasksQuery.data ?? [],
    ...searchTasksQuery,
  };
};
